import * as React from "react";
import { Typography, useTheme } from "@mui/material";
import { useLanguage } from "../../Language";
import * as dayjs from "dayjs";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { getAdapterLocale } from "../../ShadowUtils";
import { useLocalizedShortDate } from "../../../hooks/useLocalizedShortDate";

interface LoansInfoContainerProps {
  loanItem: HostSystemItemView;
}

export const LoansInfoContainer: React.FC<LoansInfoContainerProps> = ({
  loanItem,
}) => {
  const { translate } = useLanguage();
  const theme = useTheme();
  const formatDate = useLocalizedShortDate();
  const loanDueDate = dayjs(loanItem.dueDate).endOf("day");
  const today = dayjs().endOf("day");
  const daysRemaining = loanDueDate.diff(today, "day");
  const isOverdue = daysRemaining < 0;
  const remainingDisplay =
    daysRemaining === 0
      ? translate("dueToday")
      : daysRemaining < 0
      ? translate("overdue")
      : `${daysRemaining} ${translate("daysRemaining")}`;
  const formattedDueDate: string = formatDate(loanDueDate);

  return (
    <>
      <Typography
        component={"div"}
        sx={{
          color: isOverdue ? theme.palette.error.dark : "inherit",
        }}
      >
        {translate("due")}: <strong>{formattedDueDate}</strong> -{" "}
        <strong>{remainingDisplay}</strong>
      </Typography>
      {!loanItem.downloadable && (
        <Typography component={"div"}>
          {translate("renewalCounter", {
            RENEWALCOUNT: loanItem.renewalCount.toString(),
          })}
          ,{" "}
          {loanItem.renewalLimit == null ? (
            translate("renewalsUnlimited")
          ) : (
            <>
              {translate("renewalsRemaining", {
                RENEWALSREMAINING: Math.max(
                  loanItem.renewalLimit - loanItem.renewalCount,
                  0
                ).toString(),
              })}
            </>
          )}
        </Typography>
      )}
    </>
  );
};
